const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M102 265c30.137-26.667 62.47-40 97-40s66.863 13.333 97 40",
  stroke: "#1e3f6b",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 17
}), /*#__PURE__*/React.createElement("g", {
  fill: "#1e3f6b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M90.203 174.25c-1.75 0-2.5-.999-2.5-2.497v-32.475c0-1.749-.5-2.498-2.501-2.498H45.195c-4.5 0-8.752-2.498-11.252-6.245-2.5-3.997-2.5-8.993-.5-12.99L88.953 7.13c2.5-5.246 9.001-8.244 15.002-6.745s10.252 6.745 10.252 12.99v94.426c0 1.5 1 2.498 2.5 2.498h11.752c1.75 0 2.5.75 2.5 2.498v21.484c0 1.499-.75 2.498-2.5 2.498h-11.752c-1.25 0-2.5.999-2.5 2.498v32.475c0 1.498-1 2.498-2.5 2.498zm-5.001-63.95c2 0 2.5-.999 2.5-2.498V74.828c0-2.498-1.75-2.998-3-.75l-16.003 33.225c-1 1.748 0 2.997 1.75 2.997zm116.27 64.7c-25.005 0-45.758-20.234-45.758-45.215V45.351c0-24.98 20.753-45.215 45.758-45.215 25.004 0 45.758 20.234 45.758 45.215v84.434c0 24.98-20.754 45.215-45.758 45.215zm0-148.385c-10.252 0-19.254 8.494-19.254 18.736v84.434c0 10.242 9.002 18.736 19.254 18.736s19.253-8.494 19.253-18.736V45.351c0-10.242-9.002-18.736-19.253-18.736zm124.771 147.636c-1.75 0-2.5-1-2.5-2.498v-32.475c0-1.749-.5-2.498-2.5-2.498h-40.008c-4.5 0-8.751-2.498-11.252-6.245-2.5-3.997-2.5-8.993-.5-12.99L324.993 7.13c2.5-5.246 9.001-8.244 15.002-6.745 6.001 1.499 10.252 6.745 10.252 12.99v94.426c0 1.5 1 2.498 2.5 2.498H364.5c1.75 0 2.5.75 2.5 2.498v21.484c0 1.499-.75 2.498-2.5 2.498h-11.752c-1.25 0-2.5.999-2.5 2.498v32.475c0 1.498-1.001 2.498-2.501 2.498zm-5-63.95c2 0 2.5-1 2.5-2.499V74.828c0-2.498-1.75-2.998-3-.75l-16.004 33.225c-1 1.748 0 2.997 1.75 2.997zM303.902 194.887c-.935-9.901-6.553-16.813-10.7-29.108-.01-.027-.02-.053-.028-.08-.368-1-1.202-1.699-2.174-1.699-.974 0-1.808.7-2.176 1.702l-.026.074c-4.146 12.296-9.766 19.209-10.7 29.11C277.129 205.168 283.487 212 291 212c7.513 0 13.872-6.833 12.902-17.113"
})));

const Svg404 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 280,
    width: 400,
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg404, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/404.9e99589d.svg";
export { ForwardRef as ReactComponent };